// Browser stub — utf-8-validate is a native Node.js addon not needed in the browser
module.exports = {};
